// From workgroup\java\tab-model-workgroup\src\com\tableausoftware\domain\content\exceptions\errorcodes
// CONSIDER: code-gen this file from the Java sources?

export enum CommonErrorCode {
  None = 0,
  CallingUserInsufficientPermissions = 1,
  SiteUserNotFound = 4,
  SystemUserNotFound = 5,
  GroupNotFound = 6,
  WorkbookNotFound = 7,
  ViewNotFound = 8,
  ProjectNotFound = 9,
  DataConnectionNotFound = 10,
  DatasourceNotFound = 11,
  SiteNotFound = 12,
  EncryptionTokenNotFound = 13,
  FileUploadNotFound = 14,
  AdGroupNotFound = 15,
  UnexpectedErrorOccurred = 17,
  InvalidNumberOrderClauses = 18,
  InvalidPageSize = 19,
  InvalidStartIndex = 20,
  InvalidNumberFilterClauses = 21,
  InvalidSortClauseFieldName = 22,
  InProgress = 23,
  UnexpectedNullOrEmptyParameter = 24,
  UnexpectedParameterValue = 25,
  DomainNotFound = 26,
  CommentNotFound = 27,
  AsyncJobNotFound = 28,
  SubscriptionNotFound = 29,
  ADUserNotFound = 30,
  CustomViewNotFound = 31,
  OperationRequiresLocalAuthType = 32,
  InvalidSession = 46,
  MutuallyExclusiveParametersSpecified = 48,
  UnlicensedServer = 50,
  InsecureSAMLEndpoint = 53,
  RedirectToOtherPod = 55,
  SiteSAMLUserCannotAddTableauIDUser = 64,
  FeatureNotEnabled = 67,
  FileSizeTooLarge = 68,
  GuestPermittedViewNotFound = 72,
  SiteSAMLUserExistsOnAnotherSite = 76,
  SystemUserCannotBeSiteSAMLUser = 77,
  GuestUserCannotBeSiteSAMLUser = 78,
  InvalidSAMLIdpMetadata = 79,
  DataAlertNotFound = 81,
  DataAlertRecipientNotFound = 83,
  TooManyRequests = 86,
  FlowNotFound = 89,
  UnlicensedUser = 90,
  InsufficientRolePrivileges = 91,
  JobBulked = 92,
  DataRoleNotFound = 94,
  DatabaseNotFound = 95,
  MaximumRefreshTokenReached = 101,
  IncompatibleDocumentVersion = 115,
  LinkedTaskNotFound = 118,
  LinkedTaskStepNotFound = 119,
  LineageForContentNotFound = 123,
  MoveInsufficientPermissionsOnContent = 30022
}

export enum AlertErrorCode {
  AlertUnknownFailure = 1000,
  AlertRemoteUnknownFailure = 1001,
  AlertSignInFailed = 2000,
  AlertRemoteSignInFailed = 2001,
  AlertExpiredPassword = 2100,
  AlertRemoteExpiredPassword = 2101,
  AlertAccessTokenValidation = 2200,
  AlertAuthConfiguration = 2300,
  AlertConnectionFailure = 3000,
  AlertRemoteConnectionFailure = 3001,
  AlertOverlappingSchedules = 4000,
  AlertFullRefreshRequired = 5000,
  AlertOperationCanceled = 5014,
  AlertRemoteTableNotFound = 5017,
  AlertRemoteUnknownColumn = 5027,
  AlertRemoteQueryCompilation = 5029,
  AlertNoPassword = 5040,
  AlertRemoteNoPassword = 5041,
  AlertInvalidFilePath = 5042,
  AlertRemoteInvalidFilePath = 5043,
  AlertRemoteFederatedError = 5045,
  AlertRemoteInvalidSemiStructDataSchema = 5047,
  AlertRemoteUnableToConnectToFile = 5051,
  AlertRemoteIncompatibleDocumentVersion = 5053,
  AlertRemoteWDCAbortError = 5054,
  AlertRemoteWDCInvalidData = 5059,
  AlertRemoteExtractRefreshNotFinishedOnTime = 5061,
  AlertRemoteBridgeClientNotRunning = 5063,
  AlertRemoteNoDriver = 7001,
  AlertConnectionlessFailure = 10000,
  AlertConnectionNotWhitelisted = 11000,
}

export enum DataConnectionErrorCode {
  DataConnectionNullOrEmptyDataConnectionIds = 60000,
  UpdateConnectionsInvalidPort = 60005,
  FailedConnectionCredentials = 60012
}

export enum DatasourceErrorCode {
  DatasourceDescriptionGreaterThanMaxLength = 50000,
  DatasourceMoveInsufficientPermissionsOnDestinationProject = 50001,
  DatasourceMoveInsufficientPermissionsOnSourceProject = 50002,
  DatasourceMoveInsufficientPermissionsOnDatasource = 50003,
  DatasourceWithSameNameInDestinationProject = 50004,
  DatasourceNullOrEmptyProjectIds = 50005,
  DatasourceNullOrEmptyUserIds = 50006,
  DatasourceNullOrEmptyDatasourceIds = 50007,
  DatasourceNullOrEmptyWorkbookIds = 50008,
  DatasourceChangeOwnerDisabled = 50009,
  DatasourceChangeOwnerToGuest = 50010,
  DatasourceNameAlreadyExists = 50012,
  DatasourceChangeOwnerNotAllowedInPersonalSpace = 50023
}

export enum FlowRunErrorCode {
  FlowRunUnknownError =                               285000,
  FlowRunLoomSystemError =                            285001,
  FlowRunNodeExecutionError =                         285002,
  FlowRunMaestroDocumentError =                       285003,
  FlowRunUnsupportedDocumentFeature =                 285004,
  FlowRunTransientExecutionError =                    285005,
  FlowRunExecutionError =                             285006,
  FlowRunPythonScriptExecutionError =                 285007,
  FlowRunInputConnectionError =                       286000,
  FlowRunOutputError =                                286001,
  FlowRunPublishingError =                            286002,
  FlowRunInvalidUsernameOrPasswordError =             286003,
  FlowRunInputDriverError =                           286004,
  FlowRunUnapprovedRead =                             286005,
  FlowRunUnapprovedWrite =                            286006,
  FlowRunFailedToConnectExternalResourceError =       286007,
  FlowRunMissingConnectionInformation =               286008,
  FlowRunCannotConnectInputDatasource =               286009,
  FlowRunInputDatasourceMissingDBName =               286010,
  FlowRunInputDatasourceHasUserReference =            286011,
  FlowRunPublishOutputMissingURL =                    286012,
  FlowRunPublishProjectNotFound =                     286013,
  FlowRunPublishFailedPermissionDenied =              286014,
  FlowRunPublishDatasourceFailed =                    286015,
  FlowRunPublishDataRoleFailed =                      286016,
  FlowRunGeneralPublishingError =                     286017,
  FlowRunLoomCompilationError =                       287000,
  FlowRunIrrelevantLoomCompiliationError =            287001,
  FlowRunNodeCompilationError =                       287002,
  FlowRunNodeExpressionError =                        287003,
  FlowRunTimeoutError =                               287004,
  FlowRunOutputsLocationConflict =                    287005,
  FlowRunOutputLocationConflictWithInput =            287006,
  FlowRunCancelledDueToLimits =                       287007,
  FlowRunPublishDatasourcePermissionsError =          288000,
  FlowRunWriteToDBDisabledError =                     288001,
  FlowRunWriteToDBWindowsAuthError =                  288002,
  FlowRunCannotWriteToDatabase =                      288003,
  FlowRunMissingTableNameForWriteToDatabase =         288004,
  FlowRunVizportalAuthenticationError =               288005,
  FlowRunIncrementalRefreshOutputMustRunTogether =    288006,
  FlowRunIncrementalRefreshOutputMustRunInSameMode =  288007,
  FlowRunIncrementalRefreshFilterIsNull =             288008,
  FlowRunIncrementalRefreshFailed =                   288009,
  FlowRunWriteToTdeIsDeprecating =                    288010,
  FlowRunWriteOptionNotSpecified =                    288011,
  FlowRunMissingOutputStepWithSchedule =              288012,
  FlowRunMissingOutputStep =                          288013,
  FlowRunUpstreamFailure =                            288014,
}


export enum FlowErrorCode {
  FlowNullOrEmptyFlowIds = 280000,
  FlowRepositoryFileNotFound = 280001,
  FlowNullOrEmptyFlowStepIds = 280002,
  FlowFileInvalidDocument = 280003,
  FlowNameAlreadyExists = 280004,
  FlowNameTooLong = 280005,
  FlowOutputStepNotFound = 280006,
  FlowOutputStepNotExistInFlow = 280007,
  FlowRunSpecNotFound = 280008,
  FlowRunSpecMissingOutputSteps = 280009,
  FlowRunSpecNullOrEmptyIds = 280010,
  FlowNullOrEmptyUserIds = 280011,
  FlowChangeOwnerDisabled = 280012,
  FlowChangeOwnerToGuest = 280013,
  FlowMoveInsufficientPermissionsOnDestinationProject = 280014,
  FlowWithSameNameInDestinationProject = 280015,
  FlowDestinationProjectNotFound = 280016,
  FlowDescriptionTooLong = 280017,
  FlowVersionHistoryNotEnabled = 280018,
  FlowChangeOwnerToNotCurrentUser = 280023,
  FlowParametersDisabledOnSite = 280024,
  FlowParameterOverrideInvalid = 280025,
  FlowParameterOverrideMissing = 280026,
  FlowParameterNotFound = 280027,
  FlowParametersAnyTypeDisabledOnSite = 280028,
}

export enum DataRoleErrorCode {
  DataRoleDestinationProjectNotFound= 340000,
  DataRoleMoveInsufficientPermissionsOnDestinationProject = 340001,
  DataRoleWithSameNameInDestinationProject = 340002,
  DataroleChangeOwnerDisabled = 380003,
  DataroleChangeOwnerToGuest = 380004,
}

export enum UnifiedDatasourceErrorCode {
  UnifiedDatasourceNullOrEmptyDatasourceIds = 160000,
  OperationOnlySupportedForPublishedDatasource = 160001
}

export enum LoginErrorCodes {
  BadCredentials = 16,
  SspiFailed = 42,
  KerberosFailed = 43,
  ClientCertificateNotFound = 59,
  ClientCertificateUserNotFoundInCertificate = 60,
  ClientCertificateUserNotFoundOnServer = 61,
  OpenIdFailed = 69,
}

export enum ProjectErrorCode {
  ProjectNullOrEmptyProjectIds = 30000,
  ProjectNullOrEmptyUserIds = 30001,
  ProjectNameAlreadyExists = 30002,
  ProjectNameTooLong = 30003,
  ProjectDescriptionGreaterThanMaxLength = 30004,
  ProjectChangeOwnerDisabled = 30005,
  ProjectDefaultAlreadyExists = 30006,
  ProjectNameEmpty = 30007,
  DeletingDefaultProject = 30010,
  DefaultProjectCannotBeRenamed = 30011,
  TargetUserInsufficientPermissions = 30012,
  ProjectNameAlreadyExistsInDestinationProject = 30018
}

export enum TagErrorCode {
  TagNameTooLong = 110000,
  TooManyTags = 110001,

}

export enum WorkbookErrorCode {
  WorkbookDisabled = 40000,
  WorkbookDestinationProjectNotFound = 40001,
  WorkbookMoveInsufficientPermissionsOnDestinationProject = 40002,
  WorkbookMoveInsufficientPermissionsOnSourceProject = 40003,
  WorkbookMoveInsufficientPermissionsOnWorkbook = 40004,
  WorkbookNameAlreadyExistsInDestinationProject = 40005,
  WorkbookDescriptionTooLong = 40006,
  WorkbookInvalidViewPath = 40007,
  WorkbookNullOrEmptyWorkbookIds = 40008,
  WorkbookNullOrEmptyViewIds = 40009,
  WorkbookNullOrEmptyUserIds = 40010,
  WorkbookNameAlreadyExists = 40011,
  WorkbookChangeOwnerNotAllowedInPersonalSpace = 40023
}

export enum ViewErrorCode {
  ViewNameAlreadyExists = 40021
}

export enum SiteSwitchErrorCodes {
  UserNotMemberOfSiteOrSiteNotExist = 16,
  UserUnlicensedForSite = 10028,
  SiteSuspended = 10029,
  SiteLocked = 10030,
  AttemptedToSwitchSiteToCurrentSite = 10056
}

export enum SiteSettingsErrorCode {
  SiteNotFound = 12,
  SiteNameIsEmptyOrNull = 70000,
  SiteAdminCannotAddUsersButUserQuotaIsSet = 70001,
  InvalidUserQuotaOrStorageQuota = 70002, // User quota is <= 0.  User quota is less than current number of users.  User quota is greater than max allowed (2147483647). Storage quota is <= 0.
  UserQuotaGreaterThanServerLicenseLimit = 70003, // User quota is greater than server licensing limit
  InvalidCustomEmailAddress = 70004,
  SiteNameAlreadyExists = 70005,
  SiteIdsAreNullOrEmpty = 70006, // updateSiteAvailability; not relevant to web client
  SiteSubscriptionsSetWithDisabledServerSubscriptions = 70007, // Site subscriptions were set when server subscriptions were disabled
  AttemptedToUpdateDefaultSiteUrlName = 70008,
  AttemptedToSuspendDefaultSite = 70009,
  SiteNameTooLong = 70010, // Max length is 255
  SiteUrlNameTooLong = 70011, // Max length is 255
  AttemptedToDeleteDefaultSite = 70012,
  StorageQuotaLessThanStorageUsed = 70013,
  SupportUsersOwnContent = 10036,
  SiteUrlNameAlreadyExists = 70017,
  TriedToEnforceEncryptionOnSiteWithExtractedVConns = 310035,
  AccelerationSiteSheetLimitMissing = 320018,
  AccelerationSiteSheetLimitTooLow = 320019,
}

export enum WebClientErrorCode {
  NotAnInteger = 80000,
  NotASiterole = 80001,
  InvalidStartIndex = 80002,
  InvalidMaxItems = 80003,
  MutuallyExclusiveParametersPresent = 80004,
  SiteSubscriptionSettingsMissing = 80005,
  NotAScheduledAction = 80006,
  NotAScheduleType = 80007,
  NotADayOfMonth = 80008,
  NotADayOfWeek = 80009,
  NotATaskType = 80010,
  NotATargetType = 80011,
  TaskTypeIncrementExtractNotAllowed = 80012,
  TaskTypeRefreshExtractNotAllowed = 80013,
  UnableToDeleteUserWhoOwnsContent = 80014,
  NotSupportedForRemotelyRefreshedContent = 80047
}

export enum SchedulingErrorCode {
  SchedulingNullOrEmptyScheduleIds = 120000,
  SchedulingScheduleNotFound = 120001,
  SchedulingTaskNotFound = 120002,
  SchedulingNameEmpty = 120003,
  SchedulingNameTooLong = 120004,
  SchedulingNameAlreadyExists = 120005,
  SchedulingStartTimeValueInvalid = 120006,
  SchedulingEndTimeValueInvalid = 120007,
  SchedulingRecurrenceMinutesValueInvalid = 120008,
  SchedulingRecurrenceDaysOfWeekValueMissing = 120009,
  SchedulingRecurrenceDayOfMonthValueMissing = 120010,
  SchedulingPriorityValueInvalid = 120011,
  SchedulingExtractTaskExistsForTarget = 120012,
  SchedulingNotAllowedInPersonalSpace = 120024
}

export enum SubscriptionErrorCode {
  SubscriptionFrequencyChangeToERSErrorCode = 150022
}

export enum UninitializedServerErrorCode {
  UntrustedMachine = 80015,
  ReadyToInitialize = 80018
}

// From '../java/tab-model-workgroup/src/com/tableausoftware/api/rest/util/RestApiErrorCode.java'
export enum RestApiErrorCode {
  UserNotSupportedAdminOperation = 90000, //  Attempted to update a system admin
  UserInvalidSiteRole = 90001,  //  The site role given is invalid
  ADNotConfigured = 90002,  //  The server does not use AD
  ADDomainInvalid = 90003,  //  The domain given was invalid
  InvalidPageNumber = 90004,  //  The page number given is invalid
  InvalidRequestPayload = 90005,  //  The request payload is invalid
  AmbiguousWorkbookPublishSource = 90006,  //  Attempted to publish both a workbook and a file upload
  InvalidWorkbookFile = 90007,  //  Attempted to publish a non-workbook file as a workbook
  InvalidOverwriteParameter = 90008,  //  The "overwrite" parameter was provided with a non-boolean string
  InvalidPageSize = 90009,  //  The page size given is invalid
  GroupUserExists = 90010,  //  The user cannot be added to a group because it is already in said group
  GroupUserNotFound = 90011,  //  The user is not in the group so it cannot be removed from the group
  CannotModifyADGroupName = 90012,  //  The name of a active directory group cannot be modified after creation
  GroupAlreadyExists = 90013, //
  InvalidEmbedParameter = 90014,  //  The "embed" parameter was provided with a non-boolean string
  InvalidDatasourceFile = 90015,  //  Attempted to publish a non-datasource file as a datasource
  MismatchADGroupDomainNameOnSync = 90016,  //  The domainName provided does not match the domain name of the AD group being synced
  InsufficientProject_permissions = 90017,  //  The user does not have sufficient project permissions to complete the action
  InvalidShowTabsParameter = 90018,  //  The "showTabs" parameter was provided with a non-boolean string
  WorkbookChangeOwnerInsufficientPermissions = 90019,  //  The calling user does not have sufficient permissions on the workbook to change the workbook owner.
  WorkbookChangeDisplayTabsInsufficientPermissions = 90020,  //  The calling user does not have sufficient permissions on the workbook to change the display tabs status.
  InvalidOAuthParameter = 90021  //  The "oAuth" parameter was provided with a non-boolean string
}

// From '../java/tab-domain-user/src/com/tableausoftware/domain/user/exceptions/errorcodes/UserErrorCode'
export enum UserErrorCode {
  UserGroupInvalidName = 10001,
  UserDomainInvalidName = 10002,
  UserGroupWithNameAlreadyExists = 10003,
  UserCsvParamNotText = 10004,
  UserCsvParamerterTooLong = 10005,
  UserCannotSetAdminStatusForSystemAdmin = 10006,
  UserCannotRenameSystemGroup = 10007,
  UserCannotRenameNonLocalGroup = 10008,
  UserInsufficientLicenses = 10009,
  ServerUserInsufficientLicenses = 31,
  UserCannotUnlicenseAdmin = 10010,
  UserInvalidEmailAddress = 10011,
  UserSystemUserWithEmailAddressAlreadyExists = 10012,
  UserOverlappedGroupidInUpdate = 10013,
  UserAllUsersGroupAlreadyExists = 10014,
  UserGuestAlreadyExists = 10015,
  UserCannotAutocreateUser = 10016,
  UserInvalidPassword = 10017,
  UserCannotUpdatePassword = 10018,
  UserCannotUpdateFriendlyName = 10019,
  UserInvalidUserName = 10020,
  UserAlreadyExists = 10021,
  UserOverlappedSiteidInUpdate = 10022,
  UserNotSupportedGuestOperation = 10023,
  UserNotSupportedAdminOperation = 10024,
  UserNotSupportedSelfOperation = 10025,
  UserNotDeleted = 15,
  UserUnlicensed = 14,
  UserInvalidFriendlyName = 10026,
  UserInvalidSiteRole = 10027,
  UserLoginFailedUnlicensedOnSite = 10028,
  UserLoginFailedSuspendedSite = 10029,
  UserLoginFailedLockedSite = 10030,
  UserGuestLoginFailed = 10031,
  UserMissingPasswordParameters = 10032,
  UserCannotFavoriteType = 10033,
  UserCannotChangeFromSupportUser = 10035,
  UserCannotDeleteSystemUserWithAssociatedUsers = 10040,
  UserCsvMissingUsername = 10050,
  UserCsvInvalidAdminLevel = 10051,
  UserCsvInvalidLicense = 10052,
  UserCsvInvalidPublisher = 10053,
  UserCsvMissingPassword = 10054,
  UserCsvPasswordMismatch = 10055,
  UserTriedSwitchSiteToCurrentSite = 10056,
  UserInsufficientSiteQuota = 10057,
  ServerUserInsufficientSiteQuota = 32,
  UserCannotUpdateMinimumSiteRoleNonAdGroup = 10058,
  UserOpenIdBadConfig = 10059,
  UserOpenIdIdpNotReachable = 10060,
  UserOpenIdUserNotFound = 10061,
  UserOpenIdConflictingUserAccount = 10062,
  UserInvalidPasswordResetToken = 10067,
  UserPasswordResetTokenExpired = 10068,
  UserCsvUnexpectedFilenameExtension = 10070,
  UserCsvFileSizeExceedsLimit = 10071,
  UserCsvTooManyErrors = 10072,
  UserPasswordNotRespectingPolicies = 10073,
  UserMustResetPassword = 10074,
  LoginAttemptRejected = 10075,
  AccountIsBlocked = 10076,
  PasswordNotUpdated = 10077,
  UserCannotHaveSiteRoleLowerThanHighestMinimumLulGroupRole = 10079,
  UserCannotBeDeletedIfAllUsersGroupGrantSiteRoleOnLogin = 63,
}

export enum GroupErrorCode {
  GroupNullOrEmptyName = 20000,
  GroupAmbiguousNameSearch = 20001,
  GroupCannotBeDeleted = 20002,
  InvalidGroupMembershipUpdate = 20003
}

// From '../java/tab-domain-interfaces/src/com/tableausoftware/domain/ldap/LdapErrorCode.java'
export enum LdapErrorCode {
  LdapOperationsError = 100001,
  LdapProtocolError = 100002,
  LdapTimelimitExceeded = 100003,
  LdapSizelimitExceeded = 100004,
  LdapCompareFalse = 100005,
  LdapCompareTrue = 100006,
  LdapAuthMethodNotSupported = 100007,
  LdapStrongAuthRequired = 100008,
  LdapPartialResults = 100009,
  LdapReferral = 100010,
  LdapAdminLimitExceeded = 100011,
  LdapUnavailableCritExtension = 100012,
  LdapConfidentialityRequired = 100013,
  LdapSaslBindInProgress = 100014,
  LdapReferralV2 = 100015,
  LdapNoSuchAttribute = 100016,
  LdapUndefinedType = 100017,
  LdapInappropriateMatching = 100018,
  LdapConstraintViolation = 100019,
  LdapAttributeOrValueExists = 100020,
  LdapInvalidSyntax = 100021,
  LdapNoSuchObject = 100032,
  LdapAliasProblem = 100033,
  LdapInvalidDnSyntax = 100034,
  LdapIsLeaf = 100035,
  LdapAliasDerefProblem = 100036,
  LdapInappropriateAuth = 100048,
  LdapInvalidCredentials = 100049,
  LdapInsufficientRights = 100050,
  LdapBusy = 100051,
  LdapUnavailable = 100052,
  LdapUnwillingToPerform = 100053,
  LdapLoopDetect = 100054,
  LdapSortControlMissing = 100060,
  LdapOffsetRangeError = 100061,
  LdapNamingViolation = 100064,
  LdapObjectClassViolation = 100065,
  LdapNotAllowedOnNonleaf = 100066,
  LdapNotAllowedOnRdn = 100067,
  LdapAlreadyExists = 100068,
  LdapNoObjectClassMods = 100069,
  LdapResultsTooLarge = 100070,
  LdapAffectsMultipleDsas = 100071,
  LdapVirtualListViewError = 100076,
  LdapOther = 100080,
  LdapServerDown = 100081,
  LdapLocalError = 100082,
  LdapEncodingError = 100083,
  LdapDecodingError = 100084,
  LdapTimeout = 100085,
  LdapAuthUnknown = 100086,
  LdapFilterError = 100087,
  LdapUserCancelled = 100088,
  LdapParamError = 100089,
  LdapNoMemory = 100090,
  LdapConnectError = 100091,
  LdapNotSupported = 100092,
  LdapNoResultsReturned = 100094,
  LdapControlNotFound = 100093,
  LdapMoreResultsToReturn = 100095,
  LdapClientLoop = 100096,
  LdapReferralLimitExceeded = 100097,
  NotUniqueUserSearch = 101000,
  NotUniqueGroupSearch = 101001,
  UserNotFound = 101002,
  GroupNotFound = 101003,
  NullOrEmptySearch = 101004,
  UnknownObject = 101005,
  UnknownSidType = 101006,
  UnknownNativeError = 101007
}

export enum SolrErrorCode {
  SolrCommunicationError = 200000,
  SolrDisabled = 200001,
  SolrIndexingFailed = 200002
}

// From '../java/tab-domain-online/src/com/tableausoftware/domain/online/exceptions/errorcodes/OnlineErrorCode.java'
export enum OnlineErrorCode { // 250000 - 259999
  InvalidImage = 250000, // The image format is not supported or invalid.
  ImageProcessingError = 250001,  // Internal image processing error.
  StorageException = 250010, // Storage service error.
  SiteCustomizationUnavailable = 250011 // Site customization not available.
}

// From tab-domain-online-interfaces/src/com/tableausoftware/domain/online/remoteagents/RemoteAgentErrorCode.java
export enum RemoteAgentErrorCode {
  NoAgentAssignedToDataSource = 330121,
  AgentNeedsUpdateToSupportFeature = 330128,
  AgentNotConnected = 330201
}

// From workgroup/java/tab-domain-content/src/com/tableausoftware/domain/content/exceptions/errorcodes/WorkbookTemplateServiceErrorCode.java
export enum WorkbookTemplateServiceErrorCode { // 260000 - 269000
  ServiceUnavailable = 260000,
}

export enum UploadingProfilePictureErrorCode { // 270000 - 279999
  InvalidImage = 270000, // The image format is not supported or invalid.
  StorageException = 270001  // Storage service error.
}

export enum EncryptExtractErrorCode {
  PermissionDenied = 310001,
  NoEcryptableExtracts = 310002,
  AlreadyEncrypted = 310003,
  AlreadyUnencrypted = 310004,
  AlreadyEncrypting = 310005,
  AlreadyDecrypting = 310006
}

// From /tab-domain-content-interfaces/src/com/tableausoftware/domain/content/metrics/exceptions/errorcodes/MetricErrorCode.java
export enum MetricErrorCode {
  MetricMoveInsufficientPermissionsOnMetric = 300004,
  MetricNameAlreadyExistsInDestinationProject = 300005,
  MetricOwnerDoesNotHaveCreateRefresh = 300007,
  BadRequest = 300400,
  MetricNotFound = 300404,
  InvalidRequest = 300422,
  MetricNameAlreadyExists = 300424,
  InternalError = 300500,
  ServiceUnavailable = 300502,
  ServiceRequestFailed = 300503
}

export enum ExtractCreationErrorCode {
  BackgroundJobNotFound = 44,
}

export enum CollectionsErrorCode {
  UNKNOWN = 450400,
  UNAUTHORIZED = 450403,
  INVALID_SESSION = 450401,
  DUPLICATE_KEY = 450409,
  INVALID_VALUE = 450001,
  INVALID_NAME_TOO_LONG = 450004,
  INVALID_NAME_WHITESPACE = 450005,
  INVALID_NAME_NULL = 450006,
  INVALID_DESCRIPTION_TOO_LONG = 450007,
  UNABLE_TO_FETCH_FROM_CONTENT_SERVICE = 450012,
}

// From \workgroup\src\silos\tableau-server\interfaces\tab-domain-materializedviews-interfaces\src\com\tableausoftware\domain\materializedviews\exceptions\MaterializedViewErrorCode.java
export enum DataAccelerationErrorCode {
  /** (Deprecated) Site is Active, but not Enabled for Acceleration **/
  SITE_IS_NOT_ENABLED_FOR_MATERIALIZED_VIEWS = 320001,

  /** (Deprecated) Workbook Too Large to Accelerate **/
  WORKBOOK_TOO_LARGE_TO_MATERIALIZE = 320002,

  /** (Deprecated) Feature Flag Not Turned On **/
  MATERIALIZED_VIEWS_FEATURE_DISABLED = 320003,

  /** (Deprecated) Workbook without Embedded Extracts cannot be Enabled when MaterializedViewsForLiveDatasource is off */
  WORKBOOK_HAS_NO_EMBEDDED_EXTRACTS = 320004,

  /** (Deprecated) Extracts Only Workbooks Should Not Be Scheduled To Run Materialize Views Job Periodically**/
  TASKS_NOT_ALLOWED_FOR_EXTRACTS_ONLY_WORKBOOK = 320008,

  /** (Deprecated) Object Is Not Enabled For Materialized Views **/
  OBJECT_NOT_ENABLED = 320009,

  /** (Deprecated) Live Datasource Is Not Supported **/
  LIVE_DATASOURCE_NOT_SUPPORTED = 320011,

  /** (Deprecated) workbooks do not have acceleration tasks in the cases of operating on workbooks' acceleration tasks **/
  WORKBOOK_HAS_NO_ACCELERATION_TASKS = 320014,

  /** Workbook Uses Encrypted Extracts **/
  ENCRYPTED_EXTRACTS_NOT_SUPPORTED = 320005,

  /** Unable to Find the Workbook for Acceleration **/
  WORKBOOK_NOT_FOUND = 320006,

  /** Site Is Not Active */
  SITE_IS_NOT_ACTIVE = 320007,

  /** Workbook without Credentials Embedded cannot be Accelerated **/
  MISSING_CREDENTIALS = 320013,

  /** site sheet limit is reached **/
  SHEET_LIMIT_REACHED = 320015,

  /** some sheet(s) are disallowed by admins **/
  CONTAINS_ADMIN_DISALLOWED_SHEETS = 320016,

  /** the workbook has a data freshness policy that is too short to be supported by data acceleration **/
  DATA_FRESHNESS_INTERVAL_TOO_SHORT = 320017,
}

// From \workgroup\src\silos\tableau-server\interfaces\tab-domain-site-interfaces\src\com\tableausoftware\domain\site\errorcodes\SiteErrorCode.java
export enum SiteErrorCode {
  /* Run now is disabled for the site */
  SITE_RUN_NOW_DISABLED = 70026
}

export enum QuotaErrorCode {
  CONTAINER_STORAGE_QUOTA_LIMIT_EXCEEDED = 1607667353
}

export enum ContentErrorCode {
  INVALID_CONTENT_TYPE = 170005
}
